<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-users"></i>
          그룹 정보
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Main</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Group</a>
          </li>
      </ul>
    </div>
    <b-tabs v-model="index">
      <b-tab title="요약">
        <b-card>
          <!-- <div slot="header">
            <strong>그룹 정보</strong>
            <small>사용자 : {{model.count || 0}}</small>
            <span class="float-right">그룹 생성 시간 : {{model.created_at | datetime}}</span>
          </div> -->
          <b-row class="mb-2">
            <b-col md="9" class="col-form-label">
              요약
              <strong class="font_12 text-primary">사용자 : {{model.count}} </strong>
            </b-col>
            <b-col class="text-right">
              등록일 : {{model.created_at | datetime}}
            </b-col>
          </b-row>
          <hr>
          <b-row class="mb-2">
            <b-col md="2" class="col-form-label">
              서비스 타입
            </b-col>
            <b-col>
              <b-badge pill  :variant="model.service == 'Basic' ? 'info' : 'success'"> {{model.service}} </b-badge>
            </b-col>
            <b-col md="2" class="col-form-label">
              파트너(문제 발생시 연락처)
            </b-col>
            <b-col>
              <b-input type="text" v-if="model && model.partner" v-model="model.partner.username" :disabled="true" :plaintext="lock"></b-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="2" class="col-form-label">
              그룹명
            </b-col>
            <b-col>
              <b-input type="text" v-model="model.groupname" :plaintext="lock"></b-input>
            </b-col>
            <b-col md="2" class="col-form-label">
              사용자
            </b-col>
            <b-col>
              <b-input type="text" v-model="model.count" :disabled="true" :plaintext="lock"></b-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="2" class="col-form-label">
              주소
            </b-col>
            <b-col>
              <b-input type="text" v-model="model.address" :plaintext="lock"></b-input>
            </b-col>
          </b-row>
          <hr>
          <template v-if="lock">
              <template>
                <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 수정 </b-button>
              </template>
            </template>
            <template v-else>
              <b-button class="btn-add" size="sm" variant="success" @click="save"> 저장 </b-button>
              <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> 취소 </b-button>
            </template>
        </b-card>
      </b-tab>
      <!-- security policy -->
      <b-tab title="보안 정책">
        <b-card>
          <b-row>
            <b-col class="title">
              보안 정책
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2" class="col-form-label">
              비밀번호 실패 카운트
            </b-col>
            <b-col class="col-form-label">
              <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input>
            </b-col>
            <b-col md="2" class="col-form-label">
              차단 시간(5분)
            </b-col>
            <b-col class="col-form-label">
              <b-input type="number" v-model="model.security_policy.account_lock_time" :disabled="lock"></b-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2" class="col-form-label">
              비밀번호 최소길이
            </b-col>
            <b-col class="col-form-label" md="4">
              <b-input type="number" v-model="model.security_policy.password_min_len" :disabled="lock"></b-input>
            </b-col>
            <!-- <b-col md="2" class="col-form-label">
              Block time(Min)
            </b-col>
            <b-col class="col-form-label">
              <b-input type="number" v-model="model.security_policy.account_lock_time" :disabled="lock"></b-input>
            </b-col> -->
          </b-row>
          <hr>
          <b-row>
            <b-col md="2" class="col-form-label">
              비밀번호 알파벳 포함
            </b-col>
            <b-col class="col-form-label">
              <!-- <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input> -->
              <div class="checkbox-switch" v-b-tooltip.hover title="password require alphabet, ex) abcdef....">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.security_policy.password_use_alphabet" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="2" class="col-form-label">
              비밀번호 특수문자 포함
            </b-col>
            <b-col class="col-form-label">
              <!-- <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input> -->
              <div class="checkbox-switch" v-b-tooltip.hover title="password require Spacial, ex) !@#$%&*()_+-=">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.security_policy.password_use_number" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2" class="col-form-label">
              비밀번호 숫자 포함
            </b-col>
            <b-col class="col-form-label">
              <!-- <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input> -->
              <div class="checkbox-switch" v-b-tooltip.hover title="password require Number, ex) 0123456789">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.security_policy.password_use_spacial" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <hr>
            <!-- <b-col md="4">
              <b-form-group v-b-tooltip.hover title="Password Fail Count Threshold, default is 5 on system">
                <label for="ph_lock_count">비밀번호 실패 카운트</label>
                <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group v-b-tooltip.hover title="when failed too many logins, default is 5 min on system">
                <label for="ph_lock_time">차단시간(5분)</label>
                <b-input type="number" v-model="model.security_policy.account_lock_time" :disabled="lock"></b-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group v-b-tooltip.hover title="require min length">
                <label for="ph_password_min_len">비밀번호 최소길이</label>
                <b-input type="number" v-model="model.security_policy.password_min_len" :disabled="lock"></b-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="4">
              <b-form-group label="비밀번호 알파벳 포함" label-for="ph_password_use_alphabet" v-b-tooltip.hover title="password require alphabet, ex) abcdef....">
                <c-switch color="info" label size="sm" v-model="model.security_policy.password_use_alphabet" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="비밀번호 특수문자 포함" label-for="ph_password_use_number" v-b-tooltip.hover title="password require Spacial, ex) !@#$%&*()_+-=">
                <c-switch color="info" label size="sm" v-model="model.security_policy.password_use_number" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="비밀번호 숫자 포함" label-for="ph_password_use_spacial" v-b-tooltip.hover title="password require Number, ex) 0123456789">
                <c-switch color="info" label size="sm" v-model="model.security_policy.password_use_spacial" :disabled="lock" />
              </b-form-group>
            </b-col>
          </b-row>
          <hr> -->
          <b-row>
          <b-col md="6" class="col-form-label">
              사용자의 자동 로그아웃 시간 설정 (기본값 : 300 초)
              <h5>자동 로그아웃 타이머는 5분 이후에 동작합니다</h5>
            </b-col>
            <b-col md="2">
              <!-- <b-input-group size="sm"> -->
                <div class="input-group">
                  <b-input type="number" class="form-control" v-if="model && model.security_policy" :disabled="lock" v-model="model.security_policy.timeout" ></b-input>
                  <div class="input-group-append">
                    <button :disabled="true" class="btn btn-sm btn-outline-secondary" type="button">초</button>
                  </div>
                </div>
                <!-- <b-input type="number" v-if="model && model.security_policy" :disabled="lock" v-model="model.security_policy.timeout" ></b-input>
                <b-input-group-append>
                  <b-btn variant="outline-secondary">초</b-btn>
                </b-input-group-append>
              </b-input-group> -->
            </b-col>
          </b-row>
          <hr>
          <b-row class="mb-2">
            <b-col md="12" class="strong text-danger text-center">
              * 허용 IP : 그룹의 설정은 그룹의 모든 계정에 적용됩니다.
            </b-col>
          </b-row>
        <b-row class="mb-2">
          <b-col>
            <ip-list
              type="account"
              comment="그룹의 IP 접근 제어 정책이 우선 적용되고 사용자별 IP 접근 제어 정책이 적용됩니다"
              :lock="lock"
              :press="false"
              :show_button="false"
              :ip_list="model.allow_ip_account || []"
              @add="ip_add"
              @save="save"
              @remove="ip_remove"
              @clear="ip_clear">
            </ip-list>
          </b-col>
        </b-row>
        <!-- <hr> -->
        <!-- <hr> -->
        <b-row class="mb-2">
          <b-col>
            <ip-list
              type="agent"
              comment="에이전트 설치시 대상 서버의 IP 접근 제어를 설정할 수 있습니다 권장되는 설정입니다"
              :lock="lock"
              :press="false"
              :show_button="false"
              :ip_list="model.allow_ip_agent || []"
              @add="ip_add"
              @save="save"
              @remove="ip_remove"
              @clear="ip_clear">
            </ip-list>
          </b-col>
          </b-row>
          <hr>
          <template v-if="lock">
            <template>
              <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 수정 </b-button>
            </template>
          </template>
          <template v-else>
            <b-button class="btn-add" size="sm" variant="success" @click="save"> 저장 </b-button>
            <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> 취소 </b-button>
          </template>
        </b-card>
      </b-tab>
      <!-- setting -->
      <b-tab title="설정">
        <b-card>
          <b-row>
            <b-col class="title">
              설정
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2" class="col-form-label">
              허용 이메일
              <!-- <b-form-group label="허용 이메일" label-for="ph_allow_email" v-b-tooltip.hover title="전자 메일로 보안 경고 허용, 기본값은 허용입니다">
                <c-switch color="info" label size="sm" v-model="model.allow_mail" :disabled="lock" />
              </b-form-group> -->
            </b-col>
            <b-col md="4">
              <!-- <b-form-group label="단일 로그인" label-for="ph_single_login" v-b-tooltip.hover title="로그인 허용은 한 번만 허용되며 기본값은 미사용입니다"> -->
                <div class="checkbox-switch" v-b-tooltip.hover title="로그인 허용은 한 번만 허용되며 기본값은 미사용입니다">
                  <input type="checkbox" class="input-checkbox" v-model="model.allow_mail" :disabled="lock">
                  <div class="checkbox-animate" :class="{ disabled : lock }">
                      <span class="checkbox-off">OFF</span>
                      <span class="checkbox-on">ON</span>
                  </div>
                </div>
              <!-- </b-form-group> -->
              </b-col>
              <b-col class="title" md="2">
                Single Login
              </b-col>
              <b-col>
                <!-- <b-form-group label="Single Login" label-for="ph_single_login" v-b-tooltip.hover title="only one login allow, default is off">
                <c-switch color="info" label size="sm" v-model="model.single_login" :disabled="lock" />
              </b-form-group> -->
              <div class="checkbox-switch" v-b-tooltip.hover title="only one login allow, default is off">
                <input type="checkbox" class="input-checkbox" v-model="model.single_login" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="title_sub">
                Email CC
                <h6>탐지 관련 메일 수신자를 추가 할 수 있습니다</h6>
              </div>
              <b-form-textarea class="form-control" ref="email_cc_list" :rows="model && model.syslog && model.email_cc_list ? model.syslog.length + 2 : 2" max-rows="10" v-model="model.email_cc_list" :plaintext="lock"></b-form-textarea>
              <!-- <b-row>
                <b-form-textarea style="background-color:#f0f3f5;" ref="email_cc_list" :rows="model && model.syslog && model.email_cc_list ? model.syslog.length + 2 : 2" max-rows="10" v-model="model.email_cc_list" :plaintext="lock"></b-form-textarea>
              </b-row> -->
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col>
              <div class="title_sub">
                Syslog <span class="font_13" style="cursor: pointer;" @click="modal.explain = true">(what is syslog format ?)</span>

                <button type="button" class="btn btn-sm btn-insert" @click="modal.explain = true">
                  <span class="font_14 text-info">
                      <span>
                        <i class="fas fa-question-circle"></i>
                      </span>
                  </span>
                </button>
                <h6>생성 된 로그를 원격으로 보낼 수 있습니다. 주로 관제 센터의 연결에 사용됩니다.</h6>
              </div>
              <b-form-textarea class="form-control" ref="syslog_list" :rows="model && model.syslog && model.syslog_list ? model.syslog.length + 4 : 4" max-rows="10" v-model="model.syslog_list" :plaintext="lock"></b-form-textarea>
              <!-- <b-row>
                <p>You can add a mail address to the detection-related information mail reception</p>

              </b-row> -->
            </b-col>
              <!-- <b-form-group>
                <label for="ph_syslog" v-b-tooltip.hover title="Enter a syslog server ip, ex) 192.168.0.100, 192.168.0.100:511 ">
                  <h4>
                    Syslog <small style="cursor: pointer;" @click="modal.explain = true">(Syslog 형식이란 ?)</small>
                  </h4>
                  <span>생성 된 로그를 원격으로 보낼 수 있습니다. 주로 제어 센터의 연결에 사용됩니다.</span>
                </label>
                <hr>
                <b-form-textarea style="background-color:#f0f3f5;" ref="syslog_list" :rows="model && model.syslog ? model.syslog.length + 4 : 4" max-rows="10" v-model="model.syslog_list" :plaintext="lock"></b-form-textarea>
              </b-form-group>
            </b-col> -->
          </b-row>
          <hr>
          <b-row>
            <!-- <b-col md="1">
            </b-col> -->
            <!-- 알림 종류 -->
            <b-col md="2" class="col-form-label mt-4">
              WEBCastle Mode
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-4">차단</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_mode_block" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-4">탐지</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_mode_detect" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <!-- <b-col md="4">
              <b-form-group label="WEBCastle 모드">
                <b-form-checkbox style="display:inline-block;" class="mr-5" :disabled="lock" switch v-model="syslog_setting.is_allow_mode_block" >차단</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-5" :disabled="lock" switch v-model="syslog_setting.is_allow_mode_detect" >탐지</b-form-checkbox>
              </b-form-group> -->
            <!-- <b-col md="8">
              <b-form-group label="WEBCastle 위험도">
                <b-form-checkbox style="display:inline-block;" class="mr-4" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_emergency" >긴급</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-4" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_alert" >경계</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-4" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_critical" >치명적</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-4" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_error" >에러</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-4" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_warning" >주의</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-4" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_info" >정보</b-form-checkbox>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="1">
            </b-col> -->
          </b-row>
          <b-row>
            <!-- <b-col md="1">
            </b-col> -->
            <!-- 알림 종류 -->
            <b-col md="2" class="col-form-label mt-4">
              WEBCastle 위험도
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-4">긴급</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_emergency" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-4">경계</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_alert" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-3">치명적</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_critical" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-4">에러</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_error" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-4">주의</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_warning" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-4">정보</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_info" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <!-- <b-col md="1">
            </b-col> -->
          </b-row>
          <hr>
          <template v-if="lock">
            <template>
              <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 수정 </b-button>
            </template>
          </template>
          <template v-else>
            <b-button class="btn-add" size="sm" variant="success" @click="save"> 저장 </b-button>
            <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> 취소 </b-button>
          </template>
        </b-card>
      </b-tab>
      <!-- 멤버쉽(구독정보) 해지 -->
      <b-tab title="멤버쉽"
        v-if="auth && auth.profile && auth.profile.permissions && auth.profile.permissions.toUpperCase() == 'OWNER' && auth.license && !auth.license.onPremise"
        @click="signout_status"
      >
        <b-row>
          <b-col md="12">
            <h4>
              <center>서비스 이용 상태 :
                <b-badge  :variant="status.all_bill_pay && status.processing ? (status.approve ? 'danger' : 'warning') : 'success'">
                  {{status.all_bill_pay && status.processing ? (status.approve ? 'End of service' : 'Stoped') : 'Using'}}
                </b-badge>
              </center>
            </h4>
          </b-col>
        </b-row>
        <hr>
        <div>
          <b-jumbotron>
            <!-- <b-button class="text-left" :disabled="status.all_bill_pay" variant="success" href="#" @click="request_billing">
              <del v-if="status.all_bill_pay">STEP.1 Request to Billing this month.</del>
              <span v-else>STEP.1 Request to Billing this months.</span>
            </b-button> -->
            <!-- <span v-if="status.all_bill_pay">✔️ Clear</span>
            <br>
            <br> -->
            <!-- move to billing -->
            <!-- <h4 class="lead">* Make sure you don't have any outstanding payments</h4>
            <h4 class="lead">* Go to <a href="#" @click="$router.push({ name : 'billing' })">Billing</a></h4> -->
            <!-- <hr> -->
            <b-button class="text-left" variant="warning" :disabled="status.all_bill_pay && status.processing" href="#" @click="signout_stop">
              <del v-if="status.all_bill_pay && status.processing">STEP1. 중지 요청 및 이번 달 결제</del>
              <span v-else>STEP.1 서비스 사용 중지 요청 및 이번 달 결제 확인</span>
            </b-button>
            <span v-if="status.all_bill_pay && status.processing">✔️ 지우기</span>
            <br>
            <br>
            <!-- 중지 요청해도 서비스는 이용 가능 / 설정 변경 막아야 하는지 확인 필요 -->
            <h4 class="lead">* 에이전트의 설정은 승인 될 때까지 유지되며 승인 후에는 복구할 수 없습니다.</h4>
            <h4 class="lead">* 중지를 요청하면 더 이상 요금이 부과되지 않습니다.</h4>
            <h4 class="lead">* 서비스 중지 요청을 취소할 수 있습니다. <a href="#" @click="signout_cancel">"서비스 중지 및 탈퇴 요청"</a></h4>
            <hr>
            <b-button :disabled="status.approve" class="text-left" variant="danger" @click="notice">STEP.2 검토 후에도 문제가 없으면 정상적인 취소 및 알림이 발송됩니다. 이 작업은 추후에 복원이 불가능합니다.</b-button>
            <br>
            <br>
            <h4 class="lead">* 승인시 이용하는 서비스가 중지됩니다.</h4>
            <h4 class="lead">* 승인시 승인 결과를 안내 메일로 받을 수 있습니다.</h4>
            <h4 class="lead">* 에이전트 설정은 승인 될 때까지 유지되며 승인 후에는 복구할 수 없습니다.</h4>
          </b-jumbotron>
          <hr>
        </div>
      </b-tab>
      <!-- 액션 로그 -->
      <b-tab title="행위 로그">
        <actionList v-if="model.id" :group_id="model.id" />
      </b-tab>
    </b-tabs>
    <b-modal :title="modal.title"  class="modal-warning" v-model="modal.confirm" @ok="remove" ok-variant="warning">
     {{modal.msg || 'are you sure apply this?'}}
    </b-modal>
    <b-modal size="xl" title="Syslog format explain"  class="modal-info" v-model="modal.explain" ok-variant="success" ok-only hide-footer>
      <h4>Rsyslog format</h4>
      <b-table class="table_add table-striped" hover :items="log_format" :fields="['Fields', 'Value']"></b-table>
      <h4 class="title">Message Detail Format</h4>
      <hr>
      <h4 class="title_sub">
        WebCastle
      </h4>
      <pre class="form-control" style="font-size: 14px !important;">

        WAF|[출발지IP]|[목적지IP]|[서버이름]|Group:[그룹명]|Direction:[출발지IP:출발지PORT]->[도착지IP:도착지PORT]|Risk:[위험도]|Message:[정책명]|Host:[헤더의 요청 Host]|URI:URI정보]|Action:[차단|탐지]|Policy:[정책ID]:[탐지근거]
      </pre>
      <p class="col-form-label">Sample Detect or Block</p>
      <pre class="form-control" style="font-size: 14px !important;">

        WAF|158.247.215.235|35.84.178.246|vultr.guest1|Group:huni0213|Direction:35.84.178.246:58030->t1.com:80|Risk:Alert|Message:Host header is a numeric IP address|Host:158.247.215.235|URI:/.noindex.html|Action:block|Policy:[920350]Matched \"Operator `Rx' with parameter `^[\\d.:]+$' against variable `REQUEST_HEADERS:Host' (Value: `158.247.215.235' )"
      </pre>
      <p class="col-form-label">Sample Resource Alert or WAF Engine Down</p>
      <pre class="form-control" style="font-size: 14px !important;">

        WAF|dev_06|dev_06|dev_06@172.17.0.10|Group:hdh_dev_01|Direction:-|Risk:Critical|Message:ResourceAlert|Host:dev_06|URI:-|Action:CPU 14%|Policy:CPU : 10 %

        WAF|158.247.215.235|35.84.178.246|vultr.guest1|Group:huni0213|Direction:-|Risk:Critical|Message:WAF was down|Host:vultr.guest1|URI:-|Action:-|Policy:-
      </pre>

      <h4 class="title_sub">
        WSFinder
      </h4>
      <pre class="form-control" style="font-size: 14px !important;">

        WSFinder|[출발지IP]|[목적지IP]|[서버이름]|Group:[그룹명]|Direction:-|Risk:danger|Message:[위변조|탐지]|Host:[서버이름]|URI:-]|Action:[격리|탐지|위변조]|Policy:[탐지패턴근거]
      </pre>
      <p class="col-form-label">Sample Detect or forgery</p>
      <pre class="form-control" style="font-size: 14px !important;">

        WSFinder|/var/www/html/webshell/php/itsec.php|dev_04|dev_04@172.17.0.12|Group:hdh_dev_01|Direction:-|Risk:danger|Message:Regex detected|Host:dev_04|URI:-|Action:detection|Policy:11

        WSFinder|1|dev_06|dev_06@172.17.0.10|Group:hdh_dev_01|Direction:-|Risk:danger|Message:forgery detected|Host:dev_06|URI:-|Action:forgery|Policy:[1]:/var/www
      </pre>
      <p class="col-form-label">Sample Resource Alert</p>
      <pre class="form-control" style="font-size: 14px !important;">

        WSFinder|dev_06|dev_06|dev_06@172.17.0.10|Group:hdh_dev_01|Direction:-|Risk:Critical|Message:ResourceAlert|Host:dev_06|URI:-|Action:CPU 14%|Policy:CPU : 10 %
      </pre>

      <h4 class="title_sub">
        WMDS
      </h4>
      <pre class="form-control" style="font-size: 14px !important;">

        WMDS|[대상URL]|[wmds.agent]|[사이트명]|Group:[그룹명]|Direction:-|Risk:[위험도]|Message:[탐지구분]|Host:[FQDN|URL]|URI:-]|Action:[detect|forgery]|Policy:[탐지근거]
      </pre>
      <p class="col-form-label">Sample Detect or forgery</p>
      <pre class="form-control" style="font-size: 14px !important;">
        <!-- detect -->
        WMDS|http://f1security.co.kr|wmds.agent|f1security|Group:hdh_dev_01|Direction:-|Risk:danger|Message:malware detected|Host:dev_06|URI:-|Action:detect|Policy:f1security_policy_scan_daily
        <!-- forgery -->
        WMDS|http://f1security.co.kr|wmds.agent|f1security|Group:hdh_dev_01|Direction:-|Risk:danger|Message:forgery detected|Host:dev_06|URI:-|Action:forgery|Policy:/var/www
      </pre>

      <!-- <b-table hover :items="log_format_case" :fields="['Type', 'Attacker', 'Victim(Target)', 'Name',  'Action']"></b-table> -->
      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="modal.explain = false">취소</button>
      </div>
     </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>

<!-- Direction:{reportData.client_ip}:{reportData.client_port}->{reportData.host_ip}:{reportData.host_port}|Risk:{min_risk}|Message:{reportData.messages.message}|Host:{log.host}|URI:{log.uri}|Action:{((bool)log?.is_block ? "block" : "detection")}|Policy:[{reportData.messages.details.ruleId}]{reportData.messages.details.match.ToString()}" -->
